import { render, staticRenderFns } from "./ComunicationForm.vue?vue&type=template&id=02216ba3"
import script from "./ComunicationForm.vue?vue&type=script&lang=js"
export * from "./ComunicationForm.vue?vue&type=script&lang=js"
import style0 from "./ComunicationForm.vue?vue&type=style&index=0&id=02216ba3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports